
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.08 13.645H2.92a1.996 1.996 0 01-2.003-1.996V9.368a1.48 1.48 0 01.987-1.431c.243-.079.572-.272.572-.973 0-.7-.429-.951-.572-.994a1.48 1.48 0 01-.987-1.359v-2.26A1.996 1.996 0 012.92.355h13.16a1.996 1.996 0 012.003 1.996v2.246a1.488 1.488 0 01-.987 1.43c-.243.079-.572.272-.572.966s.329.923.572 1.001a1.48 1.48 0 01.987 1.43v2.225a1.996 1.996 0 01-2.003 1.996zM2.92 1.785a.565.565 0 00-.573.566v2.246A2.41 2.41 0 013.907 7a2.289 2.289 0 01-1.56 2.325v2.324a.565.565 0 00.573.565h13.16a.563.563 0 00.573-.565V9.368A2.389 2.389 0 0115.093 7a2.281 2.281 0 011.56-2.346V2.351a.564.564 0 00-.573-.565H2.92z"}})])
          )
        }
      }
    